import React, { useState, useEffect } from "react";
import {
  TextField,
  MenuItem,
  Select,
  Box,
  FormHelperText,
  Slider,
} from "@mui/material";
import { Field, useField, useFormikContext } from "formik";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useTheme } from "@mui/material/styles";

const FSelect = ({
  name,
  options,
  label,
  depends = false,
  dependsOn = null,
  dependsOnValue = null,
  ...otherProps
}) => {
  const { setFieldValue, values } = useFormikContext();
  const [field, meta, functions] = useField(name);

  const handleChange = (event) => {
    const { value } = event.target;
    setFieldValue(name, value);
  };

  const { onBlur, ...newField } = field;

  const configSelect = {
    ...newField,
    ...otherProps,
  };

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    // configSelect.helperText = meta.error;
  }

  useEffect(() => {
    if (depends && !values[dependsOn].includes(dependsOnValue)) {
      functions.setValue("");
    }
  }, [values[dependsOn]]);

  if (!depends || (depends && values[dependsOn].includes(dependsOnValue))) {
    return (
      <FormControl {...configSelect} id="FormLabel" fullWidth>
        <InputLabel id="InputLabel">{label}</InputLabel>

        <Field
          id="SelectLabel"
          component={Select}
          name={name}
          value={values[name]}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
        >
          {options.map((item, pos) => {
            return (
              <MenuItem key={pos} value={item}>
                {item}
              </MenuItem>
            );
          })}
        </Field>
        <FormHelperText>
          {meta && meta.touched ? meta.error : ""}
        </FormHelperText>
      </FormControl>
    );
  }

  return <></>;
};

export default React.memo(FSelect);
